exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.rtps-dashboard[data-v-117ba29e] {\n  padding: 50px;\n}\n.rtps-dashboard div[data-v-117ba29e] {\n    padding-bottom: 20px;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/views/RTPSDashboard.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;IACI,qBAAqB;CACxB","file":"RTPSDashboard.vue","sourcesContent":["\n.rtps-dashboard[data-v-117ba29e] {\n  padding: 50px;\n}\n.rtps-dashboard div[data-v-117ba29e] {\n    padding-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-117ba29e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/RTPSDashboard.vue
// module id = O/0s
// module chunks = 1